import React, { Suspense, lazy, useEffect } from "react";

import "./ErorBoundry.css";
import ErrConf from "../../../Images/Board/ErrConf";
import { useTranslation } from "react-i18next";
import ChatCrispComp from "../OnlineChats/ChatCrispComp";
import ReloadSVG from "../../../Images/Board/ReloadSVG";
const AllInOneSupport = lazy(() => import("../OnlineChats/AllInOneSupport"));

const ErorBoundry = ({ error, errorMessage, resetErrorBoundary }) => {
  const { t } = useTranslation();

  console.log({
    error,
    errorMessage,
    resetErrorBoundary,
  });

  const { message, stack } = error;

  const match = stack.match(
    /(at .*? \()?(http[s]?:\/\/.*\/)?(.*):(\d+):(\d+)\)?/,
  );
  const fileName = match && match[3];
  const lineNumber = match && match[4];

  useEffect(() => {
    document.body.classList.add("CrispShow");
    return () => {
      document.body.classList.remove("CrispShow");
    };
  }, []);

  return (
    <section className="ErrBoundryWrapper">
      <div className="mb-5 mt-1">
        <Suspense fallback={null}>
          <AllInOneSupport MiniShow={false} />
        </Suspense>
      </div>

      <ErrConf width="100px" fill="var(--black)" />
      <h2 className="SetDir"> {t("ThereIsAnErr")} </h2>
      <p className="ErrorNotifMoriText SetDir">{t("ErrorTextDesc")}</p>

      <button className="ErrReloadBtn" onClick={() => window.location.reload()}>
        <ReloadSVG width={"27px"} height={"27px"} fill={"var(--white)"} />
        <span className="TitleMenu"> {t("Reload")} </span>
      </button>

      <div className="ErrorShowWrapper">
        <span>{message}</span>
        <span>{fileName}</span>
        <span> at Line:{lineNumber}</span>
      </div>

      {/* <ChatCrispComp /> */}
    </section>
  );
};

export default ErorBoundry;
